import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation15 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };


    return (
        <>
      




        <div className="container mt-1 p-3 mb-1">


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}>
                        Certificate Course in Office Assistance

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>

            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%" }}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>

                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >

                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in Office Assistance
                </h5>
                <p>
                    This course covers various attributes required for an Office Assistant. This course enables one to use the range of Microsoft Office products in the provision of high-quality administrative assistance. This includes Word Processor to create various documents and reports, Spreadsheets to track his/her daily flow, and Presentation Graphics to create an effective presentation for various events.</p>


            </div>
            <hr />
            <h5 style={{ position: "relative" }}>

                Introduction
            </h5>
            <p>An Office Assistant is a professional who performs and manages office administrative duties while providing an extensive level of support to Executive Managers. An Office Assistant particularly works in any organization, private company, corporate sector etc. Office Assistants help managers make the best use of their time and are relied on heavily to ensure that work is handled efficiently and without the need for constant or direct supervision. They shall be responsible to prepare minutes of meeting, reports, letters, memorandums etc. as and when required by Executive Managers.</p>

            <hr />


            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>

            <p>This course covers various attributes required for an Office Assistant. This course enables one to use the range of Microsoft Office products in the provision of high-quality administrative assistance. This includes Word Processor to create various documents and reports, Spreadsheets to track his/her daily flow, and Presentation Graphics to create an effective presentation for various events. After completing this course, one will be able to perform the following duties:</p>
            <ul>
                <li>Providing an excellent and consistent level of administrative support to the customers</li>
                <li>Scheduling executive meetings and travel plans</li>
                <li>Maintaining various types of data required in business matters</li>
                <li>Organizing various events and maintaining event expenses</li>
                <li>Creating presentations required in business</li>
                <li>Arranging reports and data files in a perfect manner so as to avoid any inconvenience in business matters</li>
                <li>Sending bulk SMS to the employees/clients</li>
            </ul>




            <hr />

            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> Office Assistance course is jointly certified by CDOE GJUST and HKCL.</li>
                </ul>

            </div>
            <hr />
           
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                   
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                </p>
            </div>
            <hr />

            <h5>Syllabus</h5>

            <div className='p-4' >



                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Word Processing</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li>The Home Tab</li>
                                <li>The Insert Tab</li>
                                <li>The References Tab</li>
                                <li>The Mailings Tab</li>
                                <li> The Review Tab</li>
                                <li>The View Tab</li>
                                <li>Other Features</li>
                                <ul>Using Automatic Features
                                    <li>Using the PDF Format</li>
                                    <li>Using Forms and Creating Templates</li>
                                    <li>Security</li>
                                    <li>Word Processing in Other Languages</li>
                                </ul>
                                <li>   Case Studies</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">Spreadsheet</AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li>The Home Tab</li>
                                <li>The Insert Tab</li>
                                <li>The Page Layout Tab</li>
                                <li>The Data Tab</li>
                                <li>The Review and View Tabs</li>
                                <li>Additional Excel Features</li>
                                <ul>
                                    <li>Security</li>
                                    <li>Excel Extensions</li>
                                </ul>
                                <li>Case Studies</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Presentation Graphics</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li>The Home Tab</li>
                                <li>The Insert Tab</li>
                                <li>The Design Tab</li>
                                <li>The Transitions Tab</li>
                                <li>The Animations Tab</li>
                                <li>The Slide Show Tab</li>
                                <li>Other Features</li>
                                <li>Spellings, Views and Masters</li>
                                <li>Additional File Tab Options</li>
                                <li>PowerPoint Extensions</li>
                                <li>Case Studies</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Integrated Case Studies</AccordionHeader>
                        <AccordionBody accordionId="10">

                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="11">Internet</AccordionHeader>
                        <AccordionBody accordionId="11">
                            <ul>
                                <li> Navigating the Web</li>
                                <li>Finding Information on the Web</li>
                                <li>Communication Using E-Mail</li>
                                <li>Internet Concepts</li>
                                <li>Unleashing the Power of Internet</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="12">Making IT Work for You</AccordionHeader>
                        <AccordionBody accordionId="12">


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="13">Getting More from Your Computer </AccordionHeader>
                        <AccordionBody accordionId="13">



                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="14">Mail</AccordionHeader>
                        <AccordionBody accordionId="14">
                            <ul>
                                <li>Configuring an E-mail Account</li>
                                <li>Composing and Sending Mail</li>
                                <li>Receiving, Replying To and Forwarding Mail</li>
                                <li>Organizing Mail</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>




            </div >
            <hr />

            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    </>
    );
}
export default CertificateInformation15;